import { createReducer } from '@reduxjs/toolkit';
import { sectionTypes } from '@utils/sectionEnums.js';

import * as podcastActions from './podcastActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: '',
  sid: 0,
  type: sectionTypes.podcast?.type ?? 'podcast',
  isActive: false,
  isAdded: false,

  // ===== CONTENT =====
  heading: {
    id: 0,
    blockSid: 0,
    title: '',
    titleColor: '#000000',
    description: '',
    descriptionColor: '#333333',
    image: null,
    textAlign: 'center',
    divider: null,
    position: 'top',
    layout: null,
  },

  albums: null,
  items: [],

  // ===== DESIGN =====
  containerDesign: {
    isBackground: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    border: 'soft',
    shadow: null,
    padding: 12,
    margin: 15,
  },

  itemDesign: {
    backgroundColor: '#F5F5F5',
    textColor: '#000000',
    border: 'soft',
    shadow: 'none',
  },

  buttonDesign: {
    backgroundColor: null,
    textColor: null,
    opacity: null,
    border: null,
    shadow: null,
    shape: null,
    text: null,
    height: null,
  },

  designView: 'feed',
  designLayout: 'cards',
};

const podcast = createReducer(initialState, (builder) => {
  builder
    .addCase(podcastActions.podcastUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(podcastActions.podcastUpdateUID, (state, { payload: uid }) => ({ ...state, uid }))
    .addCase(podcastActions.podcastUpdateSID, (state, { payload: sid }) => ({ ...state, sid }))
    .addCase(podcastActions.podcastUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(podcastActions.podcastUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(podcastActions.podcastStore, (state, { payload }) => {
      const { id, uid, sid, isActive, isAdded, data } = payload ?? {};

      const blockContent = data?.blockContent ?? {};
      const blockDesign = data?.blockDesign ?? {};

      const heading = blockContent?.heading ?? {};
      const items = blockContent?.items ?? [];
      const albums = blockContent?.albums ?? null;

      const containerDesign = blockDesign?.containerDesign ?? {};
      const itemDesign = blockDesign?.itemDesign ?? {};
      const buttonDesign = blockDesign?.buttonDesign ?? {};

      return {
        ...state,
        requesting: false,
        error: null,

        id: id ?? 0,
        uid: uid ?? '',
        sid: sid ?? 0,
        isActive: Boolean(isActive),
        isAdded: Boolean(isAdded),

        heading: {
          ...state.heading,
          ...heading,
          title: heading?.title ?? state.heading.title,
          description: heading?.description ?? state.heading.description,
          textAlign: heading?.textAlign ?? state.heading.textAlign,
        },

        albums,
        items,

        containerDesign: { ...state.containerDesign, ...containerDesign },
        itemDesign: { ...state.itemDesign, ...itemDesign },
        buttonDesign: { ...state.buttonDesign, ...buttonDesign },

        designView: blockDesign?.view ?? state.designView,
        designLayout: blockDesign?.layout ?? state.designLayout,
      };
    })

    .addCase(podcastActions.podcastClear, () => ({ ...initialState }))

    .addCase(podcastActions.podcastUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(podcastActions.podcastUpdateIsLoading, (state, { payload }) => {
      state.requesting = payload;
    })
    .addCase(podcastActions.podcastUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(podcastActions.podcastUpdateStore, (state) => ({ ...state, error: null, requesting: false }))

    .addCase(podcastActions.podcastUpdateItems, (state, { payload: items }) => ({ ...state, items }))
    .addCase(podcastActions.podcastUpdateAlbums, (state, { payload: albums }) => ({ ...state, albums }))
    .addCase(podcastActions.podcastUpdateHeading, (state, { payload: heading }) => ({ ...state, heading: { ...state.heading, ...heading } }))
    .addCase(podcastActions.podcastUpdateBlockContent, (state, { payload }) => ({
      ...state,
      ...payload,
    }))
    .addCase(podcastActions.podcastUpdateBlockDesign, (state, { payload }) => {
      const { containerDesign, itemDesign, buttonDesign, view, layout } = payload ?? {};

      if (containerDesign) state.containerDesign = { ...state.containerDesign, ...containerDesign };
      if (itemDesign) state.itemDesign = { ...state.itemDesign, ...itemDesign };
      if (buttonDesign) state.buttonDesign = { ...state.buttonDesign, ...buttonDesign };
      if (view !== undefined) state.designView = view;
      if (layout !== undefined) state.designLayout = layout;
    });
});

export default podcast;
